module.exports = __webpack_public_path__ + "fd5a608a/img/92000000-1.cf28ff1e.png";